import {combineReducers} from 'redux';
import dashboardConfigReducer from './dashboardConfig';
import loadboardConfigReducer from './loadBoardConfig';

export default combineReducers({
  dashboardConfig: dashboardConfigReducer,
  loadboardConfig: loadboardConfigReducer
});
